import React from 'react';
import {
  Box, Text, Button, InputGroup, InputLeftElement, Input, Icon,
  Flex, IconButton
} from '@chakra-ui/react';
import { SearchIcon, AddIcon } from '@chakra-ui/icons';
import { FaPhone, FaMapMarkerAlt, FaBuilding } from 'react-icons/fa';
import { FiEdit2, FiTrash2 } from 'react-icons/fi';
import '../../Styles/theme/PasswordModel.css';

const CompanyManagerModal = ({ 
  visible, 
  companies,
  searchText,
  onSearchChange,
  onAddCompany,
  onEditCompany,
  onDeleteCompany,
  onClose
}) => {
  if (!visible) return null;

  return (
    <div className="model-overlay">
      <div 
        className="model" 
        style={{
          width: '650px',
          maxWidth: '90vw',
          maxHeight: '90vh', 
          overflowY: 'auto',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Icon as={FaBuilding} boxSize={6} color="#1C734A" mr={3} />
            <div style={{ fontWeight: 'bold', fontSize: '20px' }}>公司資料管理</div>
          </div>
          <Button
            bg="#1C734A"
            colorScheme="green"
            leftIcon={<AddIcon />}
            onClick={onAddCompany}
            size="sm"
          >
            新增公司
          </Button>
        </div>
        
        <InputGroup mb={4}>
          <InputLeftElement pointerEvents="none">
            <SearchIcon color="gray.300" />
          </InputLeftElement>
          <Input
            placeholder="搜尋公司名稱、電話、地址"
            value={searchText}
            onChange={(e) => onSearchChange(e.target.value)}
            bg="white"
            borderRadius="md"
            boxShadow="sm"
          />
        </InputGroup>

        <Box maxH="400px" overflowY="auto" borderWidth="1px" borderRadius="md">
          {companies.map((company) => (
            <Flex
              key={company.id}
              p={3}
              mb={2}
              bg="white"
              borderRadius="md"
              boxShadow="sm"
              borderWidth="1px"
              direction="row"
              align="center"
              justify="space-between"
              _hover={{ bg: "gray.50" }}
            >
              <Box flex="1">
                <Text fontWeight="semibold" mb={1}>{company.company_name}</Text>
                {company.company_tel && (
                  <Text fontSize="sm" color="gray.600" mb={1}>
                    <Icon as={FaPhone} boxSize="12px" mr={1} />
                    {company.company_tel}
                  </Text>
                )}
                {company.company_address && (
                  <Text fontSize="sm" color="gray.600">
                    <Icon as={FaMapMarkerAlt} boxSize="12px" mr={1} />
                    {company.company_address}
                  </Text>
                )}
              </Box>
              <Flex>
                <IconButton
                  size="sm"
                  icon={<FiEdit2 size="16px" />}
                  aria-label="編輯"
                  colorScheme="blue"
                  variant="ghost"
                  onClick={() => onEditCompany(company.id)}
                  mr={2}
                />
                <IconButton
                  size="sm"
                  icon={<FiTrash2 size="16px" />}
                  aria-label="刪除"
                  colorScheme="red"
                  variant="ghost"
                  onClick={(e) => onDeleteCompany(company.id, e)}
                />
              </Flex>
            </Flex>
          ))}
        </Box>
      
        <Button
          mt={4}
          size="md"
          colorScheme="gray"
          variant="outline"
          onClick={onClose}
          width="100%"
        >
          返回常用信箱管理
        </Button>
      </div>
    </div>
  );
};

export default CompanyManagerModal;
